import styles from './SegmentedControl.module.css';

export function SegmentedControl({ label, value, options, onChange }) {
  return (
    <div className={styles.segment} role="radiogroup" aria-label={label}>
      {options.map((option) => {
        const selected = option.value === value;
        return (
          <button
            key={String(option.value)}
            type="button"
            role="radio"
            aria-checked={selected}
            aria-label={option.label || option.text}
            className={selected ? styles.on : undefined}
            onClick={() => onChange(option.value)}
          >
            {option.icon}
            {option.text ? <span>{option.text}</span> : <span className="sr-only">{option.label}</span>}
          </button>
        );
      })}
    </div>
  );
}
